<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <form @submit="showExpenses">
          <div class="row">
            <div class="col-md-3">
              <p>Начало периода</p>
              <DateSelect ref="start_date"
                          :selectedDate="periodDates.start"/>
            </div>
            <div class="col-md-3">
              <p>Конец периода</p>
              <DateSelect ref="end_date"
                          :selectedDate="periodDates.end"/>
            </div>
          </div>
          <div class="row p-t-10">
            <div class="col-md-9 division_select_list" v-if="Object.keys(divisions).length">
              <button type="button" @click="showAllDivisions = !showAllDivisions" class="btn btn-default">
                {{ showAllDivisions ? 'Скрыть дивизионы' : 'Показать дивизионы' }}
              </button>
              <div v-if="showAllDivisions">
                <div class="flex flex_gap_10 mb-1">
                  <button type="button" @click="divisions[0].selected = !divisions[0].selected"
                          v-bind:class="{btn: true, 'btn-outline-primary': true, active: divisions[0].selected}">
                    Администрация
                  </button>
                  <div v-for="(division, divId) in getSortedDivisions(Object.values(divisions), [1, 201])">
                    <!--                    <DivisionSelect :division="division"/>-->
                    <DivisionBtn :division="division"/>
                  </div>
                </div>
                <hr class="m-2">
                <div class="flex flex_gap_10 flex-wrap">
                  <div v-for="(division, divId) in getSortedDivisions(Object.values(divisions), null, [1,201])"
                       v-if="+division.id !== 0">
                    <DivisionBtn :division="division"/>
                    <!--                    <DivisionSelect :division="division"/>-->
                  </div>
                </div>
                <hr class="m-2">
                <h5>Не активные дивизионы</h5>
                <InActiveDivisionSelect ref="inActiveDivisions"/>
              </div>
            </div>
            <div class="col-md-3">
              <div>
                <div>
                  <multiselect
                    v-model="selectedExpenses"
                    :options="allExpensesTypesOptions"
                    track-by="title"
                    label="title"
                    noResult="Тип расхода не найден"
                    :disabled="false"
                    :show-labels="false"
                    placeholder="Выберите тип расхода"
                    :multiple="true">
                    <template slot="noResult">Тип расхода не найден</template>
                  </multiselect>
                </div>
                <div class="m-t-10">
                  <div class="input-group">
                    <button type="button" @click="getGlobalCurrency = !getGlobalCurrency"
                            v-bind:class="{'btn-sm': true,btn: true, 'btn-outline-primary': true, active: getGlobalCurrency}">
                      приводить к единой валюте
                    </button>
                    <select class="form-control" v-model="selectedCurrency">
                      <option v-for="(currency) in $AllCurrencies" :value="currency.id">{{
                          currency && currency.currency
                        }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="m-t-10">
                  <vue-ladda button-class="btn btn-success"
                             data-style="zoom-in"
                             type="submit"
                             :loading="loading">Показать
                  </vue-ladda>
                </div>
              </div>
              <div class="m-t-20 card" v-if="summary && Object.keys(summary).length">
                <div class="card-body">
                  <h5>Итого:</h5>
                  <p v-for="(sum, curr) in summary" v-if="curr !== 'sum'">
                    {{ $AllCurrencies[curr].currency }}: <strong>{{ sum.toLocaleString('ru-RU') }}</strong>
                  </p>
                  <p>Всего {{ $AllCurrencies[resultCurrency].currency }}: <strong>{{
                      summary.sum.toLocaleString('ru-RU')
                    }}</strong></p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <pulse-loader v-if="loading" :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="!loading">
          <table v-if="records.length" class="table table-sm table-hover">
            <thead>
            <tr>
              <th>№</th>
              <th v-bind:class="{pointer: true, sorted: sortingField.pass_date}" @click="updateSorting('pass_date')">
                Дата <i class="icon-fa icon-fa-sort-amount-desc"></i></th>
              <th>Подотчетное лицо</th>
              <th>Склад</th>
              <th>Тип расхода</th>
              <th></th>
              <th v-bind:class="{pointer: true, sorted: sortingField.sum}" @click="updateSorting('sum')">Сумма <i
                class="icon-fa icon-fa-sort-amount-desc"></i></th>
              <th>Валюта</th>
              <th v-bind:class="{pointer: true, sorted: sortingField.grouped_sum}"
                  @click="updateSorting('grouped_sum')">{{ $AllCurrencies[resultCurrency].currency }} <i
                class="icon-fa icon-fa-sort-amount-desc"></i></th>
              <th>Комментарий</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in records" :key="index">
              <!--            <tr v-for="(record, index) in records" :key="index">-->
              <td>{{ index + 1 }} ({{ record.id }})</td>
              <td>{{ moment(record.pass_date, 'DD.MM.YYYY') }}</td>
              <td>{{
                  record.division_id === 0 || !record.division_id ? 'Администрация' : record?.user?.short_name
                }}
              </td>
              <td>{{
                  record.to_division_id === 0 || !record.division_id ? 'Администрация' : $AllDivisions[record.to_division_id] && $AllStores[$AllDivisions[record.to_division_id].stores[0]?.object_id]?.short_title || record.to_division_id
                }}
              </td>
              <td>{{ allExpensesTypes[record.type_id] }}</td>
              <td>{{ record.card?.number }}</td>
              <td>{{ record.sum }}</td>
              <td>{{ $AllCurrencies[record.currency_id].currency }}</td>
              <td>{{ record.grouped_sum }}</td>
              <td>{{ record.comment }}</td>
              <td>{{ record.affect_saldo ? null : 'не влияет на прибыль' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api'
import moment from 'moment'
import DateSelect from "./components/DateSelect";
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import Multiselect from 'vue-multiselect'
import DivisionSelect from "@/views/reports/components/DivisionSelect.vue";
import InActiveDivisionSelect from "@/components/divisions/InActiveDivisionSelect.vue";
import DivisionBtn from "@/views/reports/components/DivisionBtn.vue";

export default {
  title: 'Расходы за период',
  components: {
    DivisionBtn,
    InActiveDivisionSelect,
    DivisionSelect,
    DateSelect,
    VueLadda,
    Multiselect,
  },
  data() {
    return {
      sortingField: {},
      selectedCurrency: 28,
      resultCurrency: 28,
      showAllDivisions: false,
      getGlobalCurrency: true,
      selectedExpenses: [],
      summary: null,
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      allExpensesTypes: {},
      allExpensesTypesOptions: [],
      records: [],
      divisions: {},
      periodDates: {
        start: moment().format('DD.MM.YYYY'),
        end: moment().format('DD.MM.YYYY'),
      }
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllDivisions() {
      return this.$store.getters['platform/divisions']
    },
    $AllStores() {
      return this.$store.getters['platform/stores'];
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
  async mounted() {
    await this.getExpensesTypes();
    let divisions = {...this.$AllDivisions};
    divisions = {};
    Object.keys(this.$AllDivisions).forEach((divId) => {
      divisions[divId] = {...this.$AllDivisions[divId], selected: false};
    });
    divisions[0] = {selected: false, id: 0};
    this.divisions = divisions;
  },
  methods: {
    getSortedDivisions(divisions, ids = null, exclude = null) {
      divisions = divisions.filter((d) => d.is_active);
      if (ids) {
        divisions = divisions.filter((d) => ids.includes(d.id));
      }
      if (exclude) {
        divisions = divisions.filter((d) => !exclude.includes(d.id));
      }
      return _.orderBy(divisions, 'title');
    },
    async getExpensesTypes() {
      const {data} = await api.index('/reports/getExpensesType');
      if (data.success) {
        this.allExpensesTypes = data.records;
        this.allExpensesTypesOptions = Object.keys(this.allExpensesTypes).reduce((acc, e) => {
          acc.push({id: e, title: this.allExpensesTypes[e]});
          return acc;
        }, [])
      } else {
        toastr['warning']('Не удалось загрузить типы расходов');
      }
    },
    async showExpenses(e) {
      e.preventDefault();
      console.log('submit');
      this.loading = true;
      this.summary = null;
      this.sortingField = {};
      const {data} = await api.post('/reports/getExpenses', {
        date: {
          start: this.$refs.start_date.date,
          end: this.$refs.end_date.date,
        },
        divisions: Object.keys(this.divisions).reduce((acc, id) => {
          if (this.divisions[id].selected) {
            acc.push(id)
          }
          return acc;
        }, (this.$refs.inActiveDivisions?.divisions ?? []).filter((d) => d.selected).map((d) => d.id)),
        types: this.selectedExpenses,
        currency: {
          group: this.getGlobalCurrency,
          currency_id: this.selectedCurrency
        }
      });

      if (data.success) {
        this.resultCurrency = this.selectedCurrency;
        this.summary = data.records.reduce((acc, r) => {
          if (!acc[r.currency_id]) acc[r.currency_id] = 0;
          if (!acc.sum) acc.sum = 0;
          acc[r.currency_id] += r.sum;
          acc.sum += r.grouped_sum;
          return acc;
        }, {})
        this.records = data.records;
      } else {
        toastr['warning'](data.message ?? 'Ошибка загрузки расходов');
      }

      this.loading = false;
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    },
    updateSorting(field) {
      console.log(field);
      if (!this.sortingField[field]) {
        this.sortingField = {};
        this.sortingField[field] = 'desc';
      }
      if (this.sortingField[field] === 'desc') {
        this.sortingField[field] = 'asc';
      } else {
        this.sortingField[field] = 'desc';
      }
      console.log(this.records.sort((a, b) => {
        let modifier = 1;
        if (this.sortingField[field] === 'desc') modifier = -1;
        if (a[field] < b[field]) return -1 * modifier;
        if (a[field] > b[field]) return 1 * modifier;
        return 0;
      }));
    }
  }
}

</script>

<style scoped>
table thead th.sorted {
  font-weight: 700;
  font-size: 12px;
}

table th,
table tbody td {
  font-size: 11px;
}

p {
  margin-bottom: 2px;
}

.division_select_list button {
  font-size: 11px;
  padding: 1px 10px !important;
  min-width: 170px;
  margin-bottom: 2px;
}

.division_select_list stores {

}

.division_select_list user {

}
</style>
